import React, { useCallback, useState } from 'react';
import { Buttons, Content, Left, MainContent, ProjectTitle, ProjectName, Right } from './styles';
import Button from '../button';
import { useHistory } from 'react-router-dom';
import Modal from '../modals/modal';
import { saveProjectTemplateDetails } from '../../services/settingServices';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { PROJECT_ANALYTICS } from '../../global/analyticsConstants';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { convertProjectTemplateModelToInterface } from '../../mobx/common';
import CreateTaskModalV2 from '../modals/createTaskModal';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../responsiveHeader';
import {
  BUTTON_TYPE,
  ICON_BUTTON_SIZE,
  ICON_BUTTON_TYPE,
  TAB_BUTTON_TYPE,
  TEMPLATE_DETAIL_TAB_TYPES
} from '../../global/constants';
import AddIconDropdown from '../viewCard/addIconDropdown';
import Tabs from '../tabs';
import IconButton from '../button/iconButton';
import { ROUTES } from '../../routes/urls';
interface Props {
  isSettingPage?: boolean;
  loading?: boolean;
}
function TemplateHeader(props: Props) {
  const { isSettingPage = false, loading } = props;
  //States
  const [isModalOpen, setIsModalOpen] = useState(false);
  //Mobx store variables
  const { projectTemplateStore, taskStore, settingStore } = rootStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const { createTaskInput } = taskStore;
  const { loading: settingLoading } = settingStore;
  const history = useHistory();
  const isMobile = useMobileDevice();

  const handleOnClick = useCallback(async () => {
    if (currentProjectTemplate?.id) {
      createTaskInput?.setProject(currentProjectTemplate?.id, true);
      createTaskInput?.setPriority(currentProjectTemplate?.priority?.default || 0);
      createTaskInput?.setGroupId(currentProjectTemplate?.taskGroups?.[0]?.id || '');
      setIsModalOpen(true);
    }
  }, [
    createTaskInput,
    currentProjectTemplate?.id,
    currentProjectTemplate?.priority?.default,
    currentProjectTemplate?.taskGroups
  ]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const onClickTab = useCallback(
    (key?: number) => {
      if (currentProjectTemplate?.id) {
        if (key === TEMPLATE_DETAIL_TAB_TYPES.SETTINGS) {
          history.push(`${ROUTES.TEMPLATES_SETTING_DETAILS.replace(':id', currentProjectTemplate?.id)}?tab=setting`);
        } else {
          history.push(ROUTES.TEMPLATES_SETTING_DETAILS.replace(':id', currentProjectTemplate?.id));
        }
      }
    },
    [currentProjectTemplate?.id, history]
  );

  const onClickSave = useCallback(async () => {
    if (currentProjectTemplate) {
      const cloneDetails = convertProjectTemplateModelToInterface(currentProjectTemplate);
      trackAnalyticActivity(PROJECT_ANALYTICS.TEMPLATE_DATA_UPDATED);
      await saveProjectTemplateDetails(cloneDetails);
      currentProjectTemplate?.setUpdated(false);
    }
  }, [currentProjectTemplate]);

  const renderTabButton = useCallback(() => {
    const navigationTabs = [
      {
        key: TEMPLATE_DETAIL_TAB_TYPES.TASKS,
        label: 'Tasks',
        isActive: !isSettingPage
      },
      {
        key: TEMPLATE_DETAIL_TAB_TYPES.SETTINGS,
        label: 'Settings',
        isActive: isSettingPage
      }
    ];
    return (
      <Buttons>
        {navigationTabs?.map((tab) => {
          return (
            <Tabs
              key={tab?.key}
              variant={TAB_BUTTON_TYPE.STANDARD}
              title={tab?.label}
              onClick={() => onClickTab(tab?.key)}
              isActive={tab?.isActive}
            />
          );
        })}
      </Buttons>
    );
  }, [isSettingPage, onClickTab]);

  return (
    <>
      {!isMobile ? (
        <MainContent>
          <Content>
            <Left>
              <ProjectName>
                <IconButton
                  iconName='new-large-back-arrow-icon'
                  size={ICON_BUTTON_SIZE.MEDIUM}
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                  onClick={() => history.push(ROUTES.TEMPLATES_SETTING)}
                />
                <AddIconDropdown isTemplate={true} />
                <ProjectTitle>{currentProjectTemplate?.name || ''}</ProjectTitle>
              </ProjectName>
              {renderTabButton()}
            </Left>
            <Right>
              {!isSettingPage && (
                <IconButton
                  iconName='plus-icon'
                  size={ICON_BUTTON_SIZE.MEDIUM}
                  variant={ICON_BUTTON_TYPE.PRIMARY}
                  onClick={handleOnClick}
                  isDisabled={loading || settingLoading}
                />
              )}
              <Button
                title='Save Template'
                variant={BUTTON_TYPE.PRIMARY}
                size='small'
                onClick={onClickSave}
                disabled={loading || settingLoading}
              />
            </Right>
          </Content>
        </MainContent>
      ) : (
        <>
          <ResponsiveHeader title={currentProjectTemplate?.name || ''} noMargin={true} />
          {renderTabButton()}
        </>
      )}
      <Modal open={isModalOpen} maxWidth={'680px'} onClose={handleCloseModal} isResponsiveMaxWidth={true}>
        <CreateTaskModalV2 onCancel={handleCloseModal} context={{ source: 'template' }} />
      </Modal>
    </>
  );
}

export default observer(TemplateHeader);
